import IHocContext from '@@types/IHocContext';

import hoc from '~/components/hoc';
import { GlobalStyle } from '~/containers/protect-security-container/elements';
import i18n from '~/i18n';
import { globalSettingStore } from '~/stores/GlobalSettingStore';
import { useEffect } from 'react';

type ProtectSecurityContainerProps = {
  children?: React.ReactNode;
} & IHocContext;

const securityFeature = {
  get copy() {
    return i18n.t('security.feature.copy', '복사');
  },
  get paste() {
    return i18n.t('security.feature.paste', '붙여넣기');
  },
};

function makePreventAndAlert(feature: string, showError: (text: string) => void) {
  return function preventDefaultAndAlert(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    showError(`${i18n.t('security.feature.description', '제한된 기능입니다.')} (${securityFeature[feature]})`);
  };
}

const ProtectSecurityContainer: React.FC<ProtectSecurityContainerProps> = ({ children, actions }) => {
  const canCopy = globalSettingStore.security.canClipboardCopy;
  const canPaste = globalSettingStore.security.canClipboardPaste;
  const canPrint = globalSettingStore.security.canPrint;

  useEffect(() => {
    const preventDefaultAndAlert = makePreventAndAlert('copy', (text) =>
      actions.notificationActions.showWarning({ text })
    );
    if (!canCopy) {
      document.addEventListener('copy', preventDefaultAndAlert, true);
    } else {
      document.removeEventListener('copy', preventDefaultAndAlert, true);
    }
    return () => {
      document.removeEventListener('copy', preventDefaultAndAlert, true);
    };
  }, [actions.notificationActions, canCopy]);

  useEffect(() => {
    const preventDefaultAndAlert = makePreventAndAlert('paste', (text) =>
      actions.notificationActions.showWarning({ text })
    );
    if (!canPaste) {
      document.addEventListener('paste', preventDefaultAndAlert, true);
    } else {
      document.removeEventListener('paste', preventDefaultAndAlert, true);
    }
    return () => {
      document.removeEventListener('paste', preventDefaultAndAlert, true);
    };
  }, [actions.notificationActions, canPaste]);

  return (
    <>
      <GlobalStyle use={canPrint} />
      {children}
    </>
  );
};

export default hoc(ProtectSecurityContainer);
